import { ComboChart } from '../../charts/ComboChart';
import { ChartModelHelper } from '../../helpers/ChartModelHelper';
import type { IComponentFacts } from '../../types/report';
import { EmptyFacts } from '../EmptyFacts';
import { CURRENCY_AXIS_WIDTH, moneyFormatter } from './chartFormatters';
import { useChartStyle } from './useChartStyle';
import { useTrendMonths } from './useTrendMonths';

interface IProfitTrendChartProps {
  facts: IComponentFacts;
}

const LABELS = {
  revenue: 'Revenue',
  expenses: 'Expenses',
  netProfit: 'Net profit',
};

export const ProfitTrendChart = ({ facts }: IProfitTrendChartProps) => {
  const months = useTrendMonths(facts, { allowPreliminary: true });
  const style = useChartStyle(3);
  const rows = ChartModelHelper.profitTrend(facts.table, months);
  if (!ChartModelHelper.hasSeries(rows, 'revenue')) return <EmptyFacts />;
  const formatter = moneyFormatter(facts.currency);
  return (
    <ComboChart
      {...style}
      className="h-full"
      data={ChartModelHelper.relabel(rows, LABELS)}
      index="label"
      barSeries={{
        categories: [LABELS.revenue, LABELS.expenses],
        colors: ['blue', 'amber'],
        valueFormatter: formatter,
        yAxisWidth: CURRENCY_AXIS_WIDTH,
      }}
      lineSeries={{
        categories: [LABELS.netProfit],
        colors: ['emerald'],
        valueFormatter: formatter,
        showYAxis: false,
        connectNulls: true,
      }}
    />
  );
};
